import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, Send, X, Heart } from 'lucide-react';
import { useSiteSettings } from '../hooks/useSiteSettings';

export const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const settings = useSiteSettings();

  const whatsapp = settings.whatsapp || '919895959558';
  const telegram = settings.telegram || 'rishidevfoundation';
  const phone = (settings.phone_primary || '+919895959558').replace(/[^+\d]/g, '');

  const options = [
    {
      label: 'Donate',
      to: '/donate',
      icon: <Heart size={22} fill="white" />,
      bg: 'bg-gradient-to-r from-saffron-600 to-gold-500 hover:opacity-90',
      testid: 'floating-donate',
      type: 'link',
    },
    {
      label: 'WhatsApp',
      href: `https://wa.me/${whatsapp}?text=${encodeURIComponent('Namaste! I would like to know more about Rishidev Foundation.')}`,
      icon: <MessageCircle size={22} />,
      bg: 'bg-[#25D366] hover:bg-[#20BD5C]',
      testid: 'floating-whatsapp',
      type: 'external',
    },
    {
      label: 'Telegram',
      href: `https://t.me/${telegram}`,
      icon: <Send size={22} />,
      bg: 'bg-[#0088CC] hover:bg-[#0077B5]',
      testid: 'floating-telegram',
      type: 'external',
    },
    {
      label: 'Call Us',
      href: `tel:${phone}`,
      icon: <Phone size={22} />,
      bg: 'bg-charcoal-800 hover:bg-charcoal-700',
      testid: 'floating-call',
      type: 'tel',
    },
  ];

  const commonClasses = 'text-white rounded-full shadow-lg flex items-center gap-3 pl-4 pr-5 py-3 font-body font-medium text-sm transition-all duration-300 hover:scale-105';

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      {isOpen &&
        options.map((opt, i) => {
          const style = { animation: `slideIn 0.3s ease-out ${i * 0.05}s backwards` };
          if (opt.type === 'link') {
            return (
              <Link
                key={opt.label}
                to={opt.to}
                onClick={() => setIsOpen(false)}
                data-testid={opt.testid}
                className={`${opt.bg} ${commonClasses}`}
                style={style}
              >
                {opt.icon}
                <span>{opt.label}</span>
              </Link>
            );
          }
          return (
            <a
              key={opt.label}
              href={opt.href}
              target={opt.type === 'tel' ? '_self' : '_blank'}
              rel="noopener noreferrer"
              data-testid={opt.testid}
              className={`${opt.bg} ${commonClasses}`}
              style={style}
            >
              {opt.icon}
              <span>{opt.label}</span>
            </a>
          );
        })}

      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="floating-contact-toggle"
        aria-label={isOpen ? 'Close contact menu' : 'Open contact menu'}
        className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center text-white transition-all duration-300 ${
          isOpen ? 'bg-charcoal-800 hover:bg-charcoal-700 rotate-90' : 'bg-saffron-600 hover:bg-saffron-500'
        }`}
      >
        {isOpen ? <X size={26} /> : <MessageCircle size={26} />}
      </button>

      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};
